module.exports = global["jQuery"] = require("-!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./~/jquery/dist/jquery.js-exposed
// module id = 502
// module chunks = 1